import EmObject, { defineProperty, computed, action } from '@ember/object';

export class ProductTour extends EmObject {
  localStorage!: null | EmObject;
  name!: string;
  steps!: number;
  currentStep!: number;

  init() {
    super.init();

    defineProperty(
      this,
      'currentStep',
      computed<number>(`localStorage.${this.name}`, function () {
        // If localStorage isn't writeable, consider the product tour "finished"
        // and never show it.
        if (this.localStorage === null) {
          return this.steps + 1;
        }

        let step = this.localStorage.get(this.name);

        if (!step) {
          this.localStorage.set(this.name, 1);
        }

        return Number.parseInt(step ?? '1');
      }),
    );
  }

  @computed('currentStep')
  get isFinished() {
    return this.currentStep > this.steps;
  }

  @action
  finish() {
    this.localStorage?.set<any>(this.name, this.steps + 1);
  }

  @action
  next() {
    if (!this.isFinished) {
      this.localStorage?.set<any>(this.name, this.currentStep + 1);
    }
  }

  @action
  back() {
    if (!this.isFinished && this.currentStep > 1) {
      this.localStorage?.set<any>(this.name, this.currentStep - 1);
    }
  }
}
